<template>
	<div>
		<CCard>
			<CCardHeader>
				Liste des corrections

				<div class="card-header-actions">
					<CButton color="primary" v-on:click="addCreditNote()"> + Ajouter </CButton>
				</div>
			</CCardHeader>

			<CCardBody>
				<GDataTableRemote
					ref="mainTable"
					:remote-url="`/api/pos_credit_notes?invoice=${posInvoiceId}`"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination>
					<template #actions="{ item }" style="white-space: nowrap">
						<td class="text-center">
							<a href="#" @click.prevent="onItemsListClick(item)">
								<CIcon name="cil-pencil" />
							</a>
							<a class="text-center icon-space ml-3" href="#" @click="download(item)">
								<CIcon name="cil-print" />
							</a>
						</td>
					</template>
				</GDataTableRemote>
			</CCardBody>
		</CCard>
		<credit-notes-add-modal ref="addModal" v-on:refresh="refresh" />
		<credit-notes-items-list ref="itemsListModal" v-on:refresh="refresh" />
	</div>
</template>

<script>
	import creditNotesAddModal from './credit-notes-add-modal.vue';
	import GDataTableRemote from '@/components/ghostlexly-components/GDataTableRemote';
	import CreditNotesItemsList from '@/views/pages/points-of-sale/history/credit-notes/items/credit-notes-items-list';
	export default {
		components: { CreditNotesItemsList, GDataTableRemote, creditNotesAddModal },
		name: 'credit-notes-modal',
		data() {
			return {
				posInvoiceId: this.$route.params.id,
				fields: [
					{ key: 'id', label: '#' },
					{ key: 'description', label: 'Description' },
					{ key: 'total', label: 'Total' },
					{ key: 'actions', label: 'Actions', filter: false, sorter: false },
				],
			};
		},

		methods: {
			refresh() {
				this.$refs.mainTable.refresh();
			},

			addCreditNote() {
				this.$refs.addModal.posInvoiceId = this.posInvoiceId;
				this.$refs.addModal.showModal = true;
			},

			onItemsListClick(item) {
				this.$refs.itemsListModal.creditNote = item;
				this.$refs.itemsListModal.showModal = true;
			},

			download(item) {
				// download the file
				this.$axios
					.get(`/api/pos_credit_notes/pdf/${item.id}`, { responseType: 'blob' })
					.then(res => {
						if (res.status === 200 || res.status === 201) {
							let filename = res.headers['content-disposition'];
							filename = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(filename);
							if (filename != null && filename[1]) {
								filename = filename[1].replace(/['"]/g, '');
							} else {
								filename = 'file.pdf';
							}

							const url = window.URL.createObjectURL(new Blob([res.data]));
							const link = document.createElement('a');
							link.href = url;
							link.setAttribute('download', filename); //or any other extension
							document.body.appendChild(link);
							link.click();

							this.loading = false;
						}
					})
					.catch(err => {
						new Blob([err.response.data]).text().then(data => {
							data = JSON.parse(data);
							this.$toast.error(data['hydra:description']);
							this.loading = false;
						});
					});
			},
		},
	};
</script>
